import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { MAT_DATE_FORMATS } from "@angular/material/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IServiceCenterData } from "app/models/303/serviceCenterData";
import { SB303Service } from "app/services/303/303.service";
import { SharedService } from "app/services/core/shared.service";

export const DateFormats = {
  parse: {
    dateInput: ['MM/DD/YYYY']
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
    selector: 'app-dialog-view-service-center-data',
    templateUrl: './dialog-view-service-center-data.component.html',
    providers: [{ provide: MAT_DATE_FORMATS, useValue: DateFormats }],
    standalone: false
})

export class DialogViewServiceCenterDataComponent implements OnInit {

  public loading: boolean = false;
  public serviceCenterData: IServiceCenterData = {
    id: 0,
    submitted: false,
    open: false,
    submittedDate: "",
    submittedBy: "",
    licenseId: "",
    entityName: "",
    partialQuarter: false,
    lastClientDate: "",
    clientsServed: null,
    individualAdministrationSessions: null,
    groupAdministrationSessions: null,
    clientsOptedOut: null,
    deniedTotal: null,
    deniedLithium: null,
    deniedHarm: null,
    deniedPsychosis: null,
    deniedOther: null,
    behavioralReactions: null,
    severeBehavioralReactions: null,
    medicalReactions: null,
    severeMedicalReactions: null,
    averageClientUses: null,
    averageClientsGroupAdministration: null,
    averageDose: null,
    averageDoseOverFiveMG: null,
    averageDoseUnderFiveMG: null,
    postSessionReactions: null,
    reportingStartDate: "",
    reportingEndDate: "",
    deniedInconsistent: null,
    deniedIneligible: null,
    deniedIntoxicated: null,
    deniedConcerningBehavior: null,
  };

  public clientForm = new FormGroup({
    clientsServed: new FormControl(null, [Validators.required, Validators.min(0)]),
    individualAdministrationSessions: new FormControl(null, [Validators.required, Validators.min(0)]),
    groupAdministrationSessions: new FormControl(null, [Validators.required, Validators.min(0)]),
    clientsOptedOut: new FormControl(null),
  });

  public deniedForm = new FormGroup({
    deniedTotal: new FormControl(null, [Validators.required, Validators.min(0)]),
    // deniedLithium: new FormControl(null, [Validators.required, Validators.min(0)]),
    // deniedHarm: new FormControl(null, [Validators.required, Validators.min(0)]),
    // deniedPsychosis: new FormControl(null, [Validators.required, Validators.min(0)]),
    deniedInconsistent: new FormControl(null, [Validators.required, Validators.min(0)]),
    deniedIneligible: new FormControl(null, [Validators.required, Validators.min(0)]),
    deniedIntoxicated: new FormControl(null, [Validators.required, Validators.min(0)]),
    deniedConcerningBehavior: new FormControl(null, [Validators.required, Validators.min(0)]),
    deniedOther: new FormControl(null, [Validators.required, Validators.min(0)])
  });

  public reactionForm = new FormGroup({
    behavioralReactions: new FormControl(null, [Validators.required, Validators.min(0)]),
    severeBehavioralReactions: new FormControl(null, [Validators.required, Validators.min(0)]),
    medicalReactions: new FormControl(null, [Validators.required, Validators.min(0)]),
    severeMedicalReactions: new FormControl(null, [Validators.required, Validators.min(0)])
  });

  public averagesForm = new FormGroup({
    averageClientUses: new FormControl(null, [Validators.required, Validators.min(0)]),
    averageClientsGroupAdministration: new FormControl(null, [Validators.required, Validators.min(0)]),
    averageDose: new FormControl(null, [Validators.required, Validators.min(0)]),
    averageDoseOverFiveMG: new FormControl(null, [Validators.required, Validators.min(0)]),
    averageDoseUnderFiveMG: new FormControl(null, [Validators.required, Validators.min(0)])
  });

  public postSessionReactionsForm = new FormGroup({
    postSessionReactions: new FormControl(null, [Validators.required, Validators.min(0)]),
  });

  public partialQuarterForm = new FormGroup({
    lastClientDate: new FormControl(null),
  });

  public currentQuestion: number = 0;
  public questions = ['1. Session Information', '2. Denials', '3. Adverse Reactions', '4. Averages', '5. Post-Session Reactions', '6. Partial Quarter Reporting'];
  constructor(public dialogRef: MatDialogRef<DialogViewServiceCenterDataComponent>,
    public sb303Service: SB303Service,
    public sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.loading = true;
    this.sb303Service.getServiceCenterData(this.data.id).subscribe({
      next: response => this.serviceCenterData = response,
      error: e => console.log('error', e),
      complete: () =>
      {
        this.updateForm();
        this.loading = false;
      }
    });
  }

  updateForm(){
    this.clientForm.patchValue({
      clientsServed: this.serviceCenterData.clientsServed,
      individualAdministrationSessions: this.serviceCenterData.individualAdministrationSessions,
      groupAdministrationSessions: this.serviceCenterData.groupAdministrationSessions,
      clientsOptedOut: this.serviceCenterData.clientsOptedOut
    });

    this.deniedForm.patchValue({
      deniedTotal: this.serviceCenterData.deniedTotal,
      // deniedLithium: this.serviceCenterData.deniedLithium,
      // deniedHarm: this.serviceCenterData.deniedHarm,
      // deniedPsychosis: this.serviceCenterData.deniedPsychosis,
      deniedInconsistent: this.serviceCenterData.deniedInconsistent,
      deniedIneligible: this.serviceCenterData.deniedIneligible,
      deniedIntoxicated: this.serviceCenterData.deniedIntoxicated,
      deniedConcerningBehavior: this.serviceCenterData.deniedConcerningBehavior,
      deniedOther: this.serviceCenterData.deniedOther
    });

    this.reactionForm.patchValue({
      behavioralReactions: this.serviceCenterData.behavioralReactions,
      severeBehavioralReactions: this.serviceCenterData.severeBehavioralReactions,
      medicalReactions: this.serviceCenterData.medicalReactions,
      severeMedicalReactions: this.serviceCenterData.severeMedicalReactions
    });

    this.averagesForm.patchValue({
      averageClientUses: this.serviceCenterData.averageClientUses,
      averageClientsGroupAdministration: this.serviceCenterData.averageClientsGroupAdministration,
      averageDose: this.serviceCenterData.averageDose,
      averageDoseOverFiveMG: this.serviceCenterData.averageDoseOverFiveMG,
      averageDoseUnderFiveMG: this.serviceCenterData.averageDoseUnderFiveMG
    });

    this.postSessionReactionsForm.patchValue({
      postSessionReactions: this.serviceCenterData.postSessionReactions
    });

    if(this.serviceCenterData.lastClientDate != null && this.serviceCenterData.lastClientDate.length > 0)
      this.partialQuarterForm.patchValue({
        lastClientDate: new Date(this.serviceCenterData.lastClientDate)
      });

      this.disableForms();
  }

  disableForms(): void {
    this.clientForm.disable();
    this.deniedForm.disable();
    this.reactionForm.disable();
    this.averagesForm.disable();
    this.postSessionReactionsForm.disable();
    this.partialQuarterForm.disable();
  }

  changeQuestion(index: number) {
    this.currentQuestion = index;
  }

  cancel(): void {
    this.dialogRef.close('cancel');
  }
}
